import React from 'react';

import Icon from '../../../../../elements/icons/Icon';
import Link from '../../../../../elements/Link';
import styles from '../EventIcons.module.scss';

const Info = props => {
    const {event, i18n} = props;

    if (!event) return null;
    if (event.show_info_on_home || event._isCommunity) return null;

    return (
        <Link className={styles.icon} href={['/events', event.id, 'info'].join('/')}>
            <Icon src="/img/event_info.png" color={event.settings.secondary_color} />
            <div>{i18n['label.event.info']}</div>
        </Link>
    );
};

export default Info;
